import { NgModule } from '@angular/core';
import { PartnerService } from './services/partner.service';

@NgModule({
  providers: [PartnerService]
})
export class DomainPartnerModule {}